export default __webpack_public_path__ + "static/media/LifestyleCancellationPageMobileHeader1.c63eda22.jpg";